module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-08-06b31849357204489a7a4a4507955d66.webp";